import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import useFetch from 'use-http';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import DialogList from 'src/dialogs';
import TsdiAltOrSubcodeBilling from 'src/models/AP/AltOrSubcodeBilling';

interface IAltAndSubcodeBillingDialogProps {
    dialogName: string;
    subCodeId?: number;
    altSubCode?: boolean;
    billingInfo: TsdiAltOrSubcodeBilling;
    refreshSubcodeBillingInfo?: () => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
}

const AltAndSubcodeBillingDialog = (props: IAltAndSubcodeBillingDialogProps) => {
    const [altOrSubcodeBillingInfo, setAltOrSubcodeBillingInfo] = useState<TsdiAltOrSubcodeBilling>(undefined);
    const { reset, register, errors, getValues, formState } = useForm();
    const { get, /*post, del,*/ put, response } = useFetch();
    const { isDirty } = formState;

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('ReportOptionsDialog onCreate()');
    };

    useEffect(() => {
        if (!!props?.billingInfo) {
            if (props?.altSubCode !== undefined) {
                getBillingInfo();
            }
        }
    }, [props?.billingInfo, props?.altSubCode]);

    const OKClicked = () => {
        if (isDirty) {
            let data = getValues() as TsdiAltOrSubcodeBilling;
            data.invoiceFactor = !isNaN(Number(data?.invoiceFactor)) ?  Number(data.invoiceFactor) : 0;
            data.backupOfficeRate = !isNaN(Number(data?.backupOfficeRate)) ?  Number(data.backupOfficeRate) : 0;
            updateBillingRecord(data);        
            props.hideDialog();
        } else {
            alert('No changes to save.');
        }
    };

    const updateBillingRecord = async (payload: TsdiAltOrSubcodeBilling) => {
        const id = props?.billingInfo?.id;
        const subCodeType = !!props?.altSubCode ? 'altsubcode' : 'subcode';
        if (id > 0) {
            payload.id = id;
            let result = await put(`/v1.0/ClientProjectMaintenance/${subCodeType}/billing/info`, payload);

            if (!response.ok || result !== 1) {
                console.log('Unable to update billing data!');
            }
        }
    };

    const getBillingInfo = async () => {
        const id = props?.billingInfo?.id;
        const subCodeType = !!props?.altSubCode ? 'altsubcode' : 'subcode';
        if (id > 0) {
            let result = await get(`/v1.0/ClientProjectMaintenance/${subCodeType}/${id}/billing`);

            if (response.ok) {
                reset(result);
                setAltOrSubcodeBillingInfo(result);
            } else {
                console.log('Unable to get billing data!');
            }
        }
    };

    return (
        <Dialog title={!props?.altSubCode ? `Subcode ` : `Alt Subcode ` + `Billing Settings`} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <RHFInputBox
                        label="Invoice Format"
                        labelOnLeft={true}
                        labelStyle={{ width: '15rem'}}
                        defaultVal={altOrSubcodeBillingInfo?.invoiceFormat}
                        name={`invoiceFormat`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                    />
                    <RHFInputBox
                        label="Invoice Factor"
                        labelOnLeft={true}
                        labelStyle={{ width: '15rem'}}
                        defaultVal={altOrSubcodeBillingInfo?.invoiceFormat}
                        name={`invoiceFactor`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                    />
                    <label style={{border: 'solid black 1px'}}>Invoice Factor</label>
                    <RHFInputBox
                        label="Backup Office Rate"
                        labelOnLeft={true}
                        labelStyle={{ width: '15rem'}}
                        name={`backupOfficeRate`}
                        defaultVal={altOrSubcodeBillingInfo?.backupOfficeRate?.toString()}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                    />
                    <RHFCheckbox
                        onChange={(e) => {
                            let updatedBillingInfo = _.cloneDeep(altOrSubcodeBillingInfo);
                            updatedBillingInfo.chargeOfficeBackup = e.currentTarget.checked;
                            setAltOrSubcodeBillingInfo(updatedBillingInfo);
                        }}
                        name="chargeOfficeBackup"
                        checked={altOrSubcodeBillingInfo?.chargeOfficeBackup}
                        label="Charge Office Backup?"
                        register={register}
                        errors={errors}
                        bodyStyle={{ width: '10%', marginTop: '1rem' }}
                    />
                    <RHFCheckbox
                        onChange={(e) => {
                            let updatedBillingInfo = _.cloneDeep(altOrSubcodeBillingInfo);
                            updatedBillingInfo.chargeOfficeExpenses = e.currentTarget.checked;
                            setAltOrSubcodeBillingInfo(updatedBillingInfo);
                        }}
                        name="chargeOfficeExpenses"
                        checked={altOrSubcodeBillingInfo?.chargeOfficeExpenses}
                        label="Charge Office Expenses?"
                        register={register}
                        errors={errors}
                        bodyStyle={{ width: '10%', marginTop: '1rem' }}
                    />
                    <RHFCheckbox
                        onChange={(e) => {
                            let updatedBillingInfo = _.cloneDeep(altOrSubcodeBillingInfo);
                            updatedBillingInfo.breakdownOfficeExpenses = e.currentTarget.checked;
                            setAltOrSubcodeBillingInfo(updatedBillingInfo);
                        }}
                        name="breakdownOfficeExpenses"
                        checked={altOrSubcodeBillingInfo?.breakdownOfficeExpenses}
                        label="Breakdown TSDI Office Expenses?"
                        register={register}
                        errors={errors}
                        bodyStyle={{ width: '10%', marginTop: '1rem' }}
                    />
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Save Changes'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default AltAndSubcodeBillingDialog;



// WEBPACK FOOTER //
// ./src/components/client-project/dialogs/SubcodeBillingDialog.tsx